import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  imsActionsUpdateSuccess,
  imsActionsUpdateRequest,
  imsActionsUpdateFailure,
} = createActions('IMS_ACTIONS_UPDATE_SUCCESS', 'IMS_ACTIONS_UPDATE_REQUEST', 'IMS_ACTIONS_UPDATE_FAILURE');

export function updateIMS(phaseId, params) {
  return (dispatch) => {
    dispatch(imsActionsUpdateRequest());
    request(`ims_actions/${phaseId}`, {
      method: 'PUT',
      body: params,
    })
      .then(({ json }) => {
        dispatch(imsActionsUpdateSuccess(json));
      },
      (error) => {
        dispatch(imsActionsUpdateFailure(error));
      });
  };
}

export function updateIMSNote(phaseId, params) {
  return (dispatch) => {
    dispatch(imsActionsUpdateRequest());
    request(`ims_actions/${phaseId}/add_note`, {
      method: 'PUT',
      body: params,
    })
      .then(({ json }) => {
        dispatch(imsActionsUpdateSuccess(json));
      },
      (error) => {
        dispatch(imsActionsUpdateFailure(error));
      });
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/ims_actions.js